import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderComponent = _resolveComponent("HeaderComponent")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_NMessageProvider = _resolveComponent("NMessageProvider")!
  const _component_FooterComponent = _resolveComponent("FooterComponent")!
  const _component_NScrollbar = _resolveComponent("NScrollbar")!
  const _component_NConfigProvider = _resolveComponent("NConfigProvider")!

  return (_openBlock(), _createBlock(_component_NConfigProvider, null, {
    default: _withCtx(() => [
      _createVNode(_component_NScrollbar, {
        ref: "scrollbarRef",
        style: {"max-height":"100vh"},
        "x-scrollable": "",
        "on-scroll": _ctx.handleScroll
      }, {
        default: _withCtx(() => [
          _createVNode(_component_HeaderComponent, {
            scrollTop: _ctx.scrollTop,
            onUpdateScrollTop: _ctx.handleScrollTop
          }, null, 8, ["scrollTop", "onUpdateScrollTop"]),
          _createVNode(_component_NMessageProvider, null, {
            default: _withCtx(() => [
              _createVNode(_component_router_view)
            ]),
            _: 1
          }),
          _createVNode(_component_FooterComponent)
        ]),
        _: 1
      }, 8, ["on-scroll"])
    ]),
    _: 1
  }))
}